if (!window.__hoverSizesLoaded) {
  window.__hoverSizesLoaded = true;

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.hover-size__btn');
    if (!btn || btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const panel = btn.closest('.product-card__hover-sizes');
    if (panel && panel.dataset.adding) return;
    if (panel) panel.dataset.adding = '1';

    btn.classList.add('hover-size__btn--adding');

    try {
      // Let the cart drawer register itself to receive updated section HTML
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      const formData = new FormData();
      formData.set('id', variantId);
      formData.set('quantity', '1');
      formData.set('on_success', 'force_open_drawer');
      formData.set('sections', sectionsToBundle.join(','));
      formData.set('sections_url', `${Shopify.routes.root}variants/${variantId}`);

      const addResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });

      if (!addResponse.ok) throw new Error('add failed');
      const addData = await addResponse.json();

      const cartData = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

      if (addData.sections) {
        cartData.sections = addData.sections;
      }

      // Dispatch cart:change — this triggers the cart drawer to update and open
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            onSuccessDo: 'force_open_drawer',
            cart: cartData
          }
        })
      );

      btn.classList.remove('hover-size__btn--adding');
      btn.classList.add('hover-size__btn--added');
      setTimeout(() => {
        btn.classList.remove('hover-size__btn--added');
        if (panel) delete panel.dataset.adding;
      }, 2000);

    } catch (e) {
      btn.classList.remove('hover-size__btn--adding');
      if (panel) delete panel.dataset.adding;
    }
  });
}
